import { DashboardPage } from 'foundations-components/transitional/components/DashboardPage';
import { UsageScreenProvider } from 'marketplace-ui-tracking';
import { NavMarker } from 'react-rhumb';
import { ErrorBoundary } from '../components/ErrorBoundary';
import { ProductPageHeader } from '../components/headers/ProductPageHeader';
import { Screens } from '../constants/usage';
import { jsx as _jsx } from "react/jsx-runtime";
export function Reviews() {
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "REVIEWS_LOAD",
    children: /*#__PURE__*/_jsx(UsageScreenProvider, {
      screen: Screens.APPS,
      children: /*#__PURE__*/_jsx(DashboardPage, {
        headerComponent: /*#__PURE__*/_jsx(ProductPageHeader, {
          pathKey: "LISTING_REVIEWS",
          title: "Test Listing Name"
        }),
        children: /*#__PURE__*/_jsx(ErrorBoundary, {})
      })
    })
  });
}